import { render, staticRenderFns } from "./AppointmentsShowroom.vue?vue&type=template&id=cf50160e&"
import script from "./AppointmentsShowroom.vue?vue&type=script&lang=js&"
export * from "./AppointmentsShowroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports